import React, { useEffect, useState } from "react";

const Player = ({ playerToken, banner, config }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, [2000]);
  }, []);
  return (
    <>
      {loading && (
        <>
          <div className="load-parent main">
            <img src={banner ? banner : config.banner} className="bg-event" />
            <span className="shadow">{""}</span>
            <div className="load-avatar">
              <svg viewBox="25 25 50 50">
                <circle r="20" cy="50" cx="50"></circle>
              </svg>
            </div>
          </div>
        </>
      )}
      <iframe
        allowFullScreen="allowfullscreen"
        mozallowfullscreen="mozallowfullscreen"
        msallowfullscreen="msallowfullscreen"
        oallowfullscreen="oallowfullscreen"
        webkitallowfullscreen="webkitallowfullscreen"
        src={`${config.launcher}?referrer=${playerToken}`}
        style={{ width: "100%", height: "100%" }}
        allow="camera *;microphone *"
      />
    </>
  );
};

export default Player;
